export const aboutData = {
    title: 'About me 👋🏼',
    contents1: "Most people know me as Loostie, I am a fullstack developer from Norway.",
    contents2: "During the day I work as a fullstack developer and system administrator for a local IT-company. I have about 5 years of experience.",
    contents3: "I enjoy learning new technologies and expand my knowledge. During freetime I enjoy socializing with friends, I also produce electronic music! (In FL Studio, if you're curious)"
}